// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Disable Account — standalone page (.da-*) */

.da-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 64px;
  max-width: 1200px;
  margin: 0 auto;
}

.da-page *,
.da-page *::before,
.da-page *::after {
  box-sizing: border-box;
}

.da-page__crumbs {
  margin-bottom: 18px;
}

.da-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.da-page__crumbItem--active {
  color: #e7e7e7;
}

body.light_theme .da-page__crumbItem--active {
  color: #101828;
}

.da-page__crumbSep {
  color: #8e939c;
}

.da-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.da-inner {
  max-width: 560px;
  margin: 0 auto;
  padding: 24px 16px 0;
  text-align: center;
}

.da-page__title {
  margin: 50px 30px 28px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e7e7e7;
  text-align: left;
}

body.light_theme .da-page__title {
  color: #101828;
}

.da-art {
  margin: 0 auto 10px;
  max-width: 300px;
}

.da-art img {
  display: block;
  width: 100%;
  height: auto;
}

.da-intro {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.55;
  color: #ededed;
  text-align: left;
}

body.light_theme .da-intro {
  color: #101828;
}

.da-list {
  margin: 0 0 36px;
  padding: 0;
  list-style: none;
  text-align: left;
}

.da-list__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  color: #e8e8e8;
}

body.light_theme .da-list__item {
  color: #101828;
}

.da-list__item:last-child {
  margin-bottom: 0;
}

/* Small solid hexagon bullet */
.da-list__hex {
  flex: 0 0 auto;
  width: 14px;
  height: 16px;
  margin-top: 6px;
  background: #f5f5f5;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}

body.light_theme .da-list__hex {
  background: #101828;
}

.da-list__text {
  flex: 1 1;
  min-width: 0;
}

.da-btnPrimary {
  width: 100%;
  max-width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.da-btnPrimary:hover {
  opacity: 0.8;
}

.da-btnPrimary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.da-prefetchHint {
  margin: 0 0 16px;
  font-size: 14px;
  color: #667085;
  text-align: left;
}

.da-errorBanner {
  padding: 12px 14px;
  border-radius: 10px;
  background: #fef3f2;
  border: 1px solid #fecdca;
  color: #b42318;
  font-size: 14px;
}

.da-errorBanner--page {
  margin-bottom: 16px;
  text-align: left;
}

.da-errorBanner__text {
  margin: 0 0 10px;
}

.da-btnGhost {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid #d0d5dd;
  background: #fff;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.da-btnGhost:hover:not(:disabled) {
  background: #f9fafb;
}

.da-btnGhost--inline {
  border-radius: 8px;
  font-size: 13px;
  min-height: 36px;
}

.da-methodStrip {
  margin: 0 0 20px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #eaecf0;
  background: #fcfcfd;
  text-align: left;
}

.da-methodStrip__title {
  font-size: 13px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 10px;
}

.da-methodStrip__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.da-methodStrip__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #101828;
}

.da-methodStrip__name {
  color: #475467;
}

.da-methodStrip__on {
  font-weight: 600;
  color: #039855;
}

.da-methodStrip__off {
  font-weight: 500;
  color: #98a2b3;
}

.da-warnBanner {
  margin: 0 0 20px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fffaeb;
  border: 1px solid #fedf89;
  color: #b54708;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

@media (max-width: 991px) {

  .da-page__title {
    margin: 40px 20px 20px;
    font-size: 26px;
  }

}


@media (max-width: 767px) {
  .da-page__title {
    font-size: 22px;
    margin: 30px 0px 0px;
  }


  .da-art {
    max-width: 220px;
  }

  .da-intro {
    margin: 0 0 10px;
    font-size: 15px;
  }

  .da-list__item {
    font-size: 15px;
  }

  .da-btnPrimary {
    height: 42px;
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/disableAccount.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE;IACE,sBAAsB;IACtB,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;AAEF","sourcesContent":["/* Disable Account — standalone page (.da-*) */\n\n.da-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 64px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.da-page *,\n.da-page *::before,\n.da-page *::after {\n  box-sizing: border-box;\n}\n\n.da-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.da-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.da-page__crumbItem--active {\n  color: #e7e7e7;\n}\n\nbody.light_theme .da-page__crumbItem--active {\n  color: #101828;\n}\n\n.da-page__crumbSep {\n  color: #8e939c;\n}\n\n.da-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.da-inner {\n  max-width: 560px;\n  margin: 0 auto;\n  padding: 24px 16px 0;\n  text-align: center;\n}\n\n.da-page__title {\n  margin: 50px 30px 28px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e7e7e7;\n  text-align: left;\n}\n\nbody.light_theme .da-page__title {\n  color: #101828;\n}\n\n.da-art {\n  margin: 0 auto 10px;\n  max-width: 300px;\n}\n\n.da-art img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.da-intro {\n  margin: 0 0 20px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.55;\n  color: #ededed;\n  text-align: left;\n}\n\nbody.light_theme .da-intro {\n  color: #101828;\n}\n\n.da-list {\n  margin: 0 0 36px;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n}\n\n.da-list__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 14px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #e8e8e8;\n}\n\nbody.light_theme .da-list__item {\n  color: #101828;\n}\n\n.da-list__item:last-child {\n  margin-bottom: 0;\n}\n\n/* Small solid hexagon bullet */\n.da-list__hex {\n  flex: 0 0 auto;\n  width: 14px;\n  height: 16px;\n  margin-top: 6px;\n  background: #f5f5f5;\n  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\n}\n\nbody.light_theme .da-list__hex {\n  background: #101828;\n}\n\n.da-list__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.da-btnPrimary {\n  width: 100%;\n  max-width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.da-btnPrimary:hover {\n  opacity: 0.8;\n}\n\n.da-btnPrimary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.da-prefetchHint {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: #667085;\n  text-align: left;\n}\n\n.da-errorBanner {\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fef3f2;\n  border: 1px solid #fecdca;\n  color: #b42318;\n  font-size: 14px;\n}\n\n.da-errorBanner--page {\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.da-errorBanner__text {\n  margin: 0 0 10px;\n}\n\n.da-btnGhost {\n  min-height: 40px;\n  padding: 0 18px;\n  border-radius: 999px;\n  border: 1px solid #d0d5dd;\n  background: #fff;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.da-btnGhost:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.da-btnGhost--inline {\n  border-radius: 8px;\n  font-size: 13px;\n  min-height: 36px;\n}\n\n.da-methodStrip {\n  margin: 0 0 20px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid #eaecf0;\n  background: #fcfcfd;\n  text-align: left;\n}\n\n.da-methodStrip__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #344054;\n  margin-bottom: 10px;\n}\n\n.da-methodStrip__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.da-methodStrip__item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  color: #101828;\n}\n\n.da-methodStrip__name {\n  color: #475467;\n}\n\n.da-methodStrip__on {\n  font-weight: 600;\n  color: #039855;\n}\n\n.da-methodStrip__off {\n  font-weight: 500;\n  color: #98a2b3;\n}\n\n.da-warnBanner {\n  margin: 0 0 20px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: #fffaeb;\n  border: 1px solid #fedf89;\n  color: #b54708;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n}\n\n@media (max-width: 991px) {\n\n  .da-page__title {\n    margin: 40px 20px 20px;\n    font-size: 26px;\n  }\n\n}\n\n\n@media (max-width: 767px) {\n  .da-page__title {\n    font-size: 22px;\n    margin: 30px 0px 0px;\n  }\n\n\n  .da-art {\n    max-width: 220px;\n  }\n\n  .da-intro {\n    margin: 0 0 10px;\n    font-size: 15px;\n  }\n\n  .da-list__item {\n    font-size: 15px;\n  }\n\n  .da-btnPrimary {\n    height: 42px;\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
